
<div
  :class="
    classes(
      n(),
      computedDisabled && n('--disabled'),
      computedChecked && n('--checked'),
      !computedMarginLess && n('--margin-less')
    )
  "
  role="radio"
  :aria-checked="computedChecked"
  :aria-disabled="computedDisabled"
  @click="handleClick"
>
  <!-- 内容区域 -->
  <div :class="n('content')">
    <div :class="n('main')">
      <!-- 左侧图标 -->
      <component
        :is="icon"
        v-if="icon"
        :class="n('icon')"
      />
      <div :class="n('info')">
        <!-- 主文案 -->
        <div
          v-if="label"
          :class="n('label')"
        >
          {{ label }}
        </div>
        <!-- 描述文案 -->
        <div
          v-if="desc"
          :class="n('desc')"
        >
          {{ desc }}
        </div>
      </div>
    </div>
    <!-- 右侧图标 -->
    <OkOIcon
      v-if="computedChecked"
      :color="iconColor"
      :class="n('checked-icon')"
      aria-hidden="true"
    />
  </div>
  <!-- 分割线 -->
  <Divider :class="n('divider')" />
</div>
